import dayjs from "dayjs";
import type { RecentUpdate } from "../../hooks/react-query/linehaul/useTransitRecentUpdates";
import type { TripDetails } from "../../pages/linehaul/tripsDashboard/inTransit/TransitDashboardTripDetailsRightPanel/TripInfoTabs/TripDetails";
import type { Stop } from "../../pages/linehaul/tripsDashboard/inTransit/TransitDashboardTripDetailsRightPanel/TripInfoTabs/TripDetails/Stops";

/**
 * Mock data for Recent Updates feature in Transit Dashboard
 * Matches the actual API response structure
 */
export const mockRecentUpdates = {
  default: [
    {
      tripNumber: 294039,
      loadBoardScheduleId: 3104817,
      bookingNumber: "123456",
      trailerNumber: "123456",
      lastModifiedOn: dayjs().subtract(1, "minute"),
      etaStatus: "Late",
      eta: dayjs("2024-06-23T15:00:00"),
      ibCutTime: dayjs("2024-06-23T12:00:00"),
      isStarred: true,
      status: "ENRT",
      stops: ["CHT"],
      carrier: {
        id: 92027,
        name: "Jackson Transport",
        code: "M027",
        isActive: true,
      },
      employeeDrivers: [],
      origin: {
        id: 101,
        code: "ATL",
        ownership: "C",
        lhRegionId: 1,
        timeZone: "America/New_York",
      },
      destination: {
        id: 102,
        code: "SFO",
        ownership: "C",
        lhRegionId: 5,
        timeZone: "America/Los_Angeles",
      },
    },
    {
      tripNumber: 346383,
      loadBoardScheduleId: 3104818,
      bookingNumber: "123457",
      trailerNumber: "123457",
      lastModifiedOn: dayjs().subtract(1, "minute"),
      etaStatus: "OnTime",
      eta: dayjs("2024-06-23T15:00:00"),
      ibCutTime: dayjs("2024-06-23T12:00:00"),
      isStarred: false,
      status: "UNLD",
      stops: ["CHT"],
      carrier: {
        id: 92027,
        name: "Jackson Transport",
        code: "M027",
        isActive: true,
      },
      employeeDrivers: [],
      origin: {
        id: 101,
        code: "ATL",
        ownership: "C",
        lhRegionId: 1,
        timeZone: "America/New_York",
      },
      destination: {
        id: 102,
        code: "SFO",
        ownership: "C",
        lhRegionId: 5,
        timeZone: "America/Los_Angeles",
      },
    },
    {
      tripNumber: 58363,
      loadBoardScheduleId: 3104819,
      bookingNumber: "123458",
      trailerNumber: "123458",
      lastModifiedOn: dayjs().subtract(1, "minute"),
      etaStatus: "OnTime",
      eta: dayjs("2024-06-23T15:00:00"),
      ibCutTime: dayjs("2024-06-23T12:00:00"),
      isStarred: false,
      status: "ARIV",
      stops: ["CHT"],
      carrier: {
        id: 92027,
        name: "Jackson Transport",
        code: "M027",
        isActive: true,
      },
      employeeDrivers: [],
      origin: {
        id: 101,
        code: "ATL",
        ownership: "C",
        lhRegionId: 1,
        timeZone: "America/New_York",
      },
      destination: {
        id: 102,
        code: "SFO",
        ownership: "C",
        lhRegionId: 5,
        timeZone: "America/Los_Angeles",
      },
    },
    {
      tripNumber: 103734,
      loadBoardScheduleId: 3104820,
      bookingNumber: "123459",
      trailerNumber: "123459",
      lastModifiedOn: dayjs().subtract(2, "minute"),
      etaStatus: "AtRisk",
      eta: dayjs("2024-06-23T15:00:00"),
      ibCutTime: dayjs("2024-06-23T12:00:00"),
      isStarred: true,
      status: "ENRT",
      stops: ["CHT"],
      carrier: {
        id: 92027,
        name: "Jackson Transport",
        code: "M027",
        isActive: true,
      },
      employeeDrivers: [],
      origin: {
        id: 101,
        code: "ATL",
        ownership: "C",
        lhRegionId: 1,
        timeZone: "America/New_York",
      },
      destination: {
        id: 102,
        code: "SFO",
        ownership: "C",
        lhRegionId: 5,
        timeZone: "America/Los_Angeles",
      },
    },
    {
      tripNumber: 404840,
      loadBoardScheduleId: 3104821,
      bookingNumber: "123460",
      trailerNumber: "123460",
      lastModifiedOn: dayjs().subtract(5, "minute"),
      etaStatus: "Late",
      eta: dayjs("2024-06-23T15:00:00"),
      ibCutTime: dayjs("2024-06-23T12:00:00"),
      isStarred: false,
      status: "ENRT",
      stops: ["CHT"],
      carrier: {
        id: 92027,
        name: "Jackson Transport",
        code: "M027",
        isActive: true,
      },
      employeeDrivers: [],
      origin: {
        id: 101,
        code: "ATL",
        ownership: "C",
        lhRegionId: 1,
        timeZone: "America/New_York",
      },
      destination: {
        id: 102,
        code: "SFO",
        ownership: "C",
        lhRegionId: 5,
        timeZone: "America/Los_Angeles",
      },
    },
    {
      tripNumber: 298471,
      loadBoardScheduleId: 3104822,
      bookingNumber: "789012",
      trailerNumber: "789012",
      lastModifiedOn: dayjs().subtract(15, "minute"),
      etaStatus: "OnTime",
      eta: dayjs("2024-06-24T18:00:00"),
      ibCutTime: dayjs("2024-06-24T14:00:00"),
      isStarred: true,
      status: "ENRT",
      stops: ["CHT"],
      carrier: {
        id: 92015,
        name: "Swift Logistics",
        code: "M015",
        isActive: true,
      },
      employeeDrivers: [],
      origin: {
        id: 101,
        code: "ATL",
        ownership: "C",
        lhRegionId: 1,
        timeZone: "America/New_York",
      },
      destination: {
        id: 105,
        code: "MIA",
        ownership: "C",
        lhRegionId: 2,
        timeZone: "America/New_York",
      },
    },
    {
      tripNumber: 187652,
      loadBoardScheduleId: 3104823,
      bookingNumber: "345678",
      trailerNumber: "345678",
      lastModifiedOn: dayjs().subtract(30, "minute"),
      etaStatus: "AtRisk",
      eta: dayjs("2024-06-25T21:00:00"),
      ibCutTime: dayjs("2024-06-25T18:00:00"),
      isStarred: false,
      status: "ENRT",
      stops: [],
      carrier: {
        id: 92042,
        name: "Rapid Freight",
        code: "M042",
        isActive: true,
      },
      employeeDrivers: [],
      origin: {
        id: 107,
        code: "DFW",
        ownership: "C",
        lhRegionId: 4,
        timeZone: "America/Chicago",
      },
      destination: {
        id: 108,
        code: "HOU",
        ownership: "C",
        lhRegionId: 4,
        timeZone: "America/Chicago",
      },
    },
    {
      tripNumber: 512934,
      loadBoardScheduleId: 3104824,
      bookingNumber: "901234",
      trailerNumber: "901234",
      lastModifiedOn: dayjs().subtract(1, "hour"),
      etaStatus: "OnTime",
      eta: dayjs("2024-06-25T12:00:00"),
      ibCutTime: dayjs("2024-06-25T09:00:00"),
      isStarred: false,
      status: "ENRT",
      stops: ["PHX"],
      carrier: {
        id: 92028,
        name: "West Coast Express",
        code: "M028",
        isActive: true,
      },
      employeeDrivers: [],
      origin: {
        id: 2,
        code: "LAX",
        ownership: "C",
        lhRegionId: 5,
        timeZone: "America/Los_Angeles",
      },
      destination: {
        id: 110,
        code: "DEN",
        ownership: "C",
        lhRegionId: 6,
        timeZone: "America/Denver",
      },
    },
  ],
} as const satisfies Record<string, RecentUpdate[]>;

/**
 * Mock data for Transit Dashboard Trips In Transit (new API format)
 * This mock matches the inTransitTripsResponseSchema input format
 */
export const mockInTransitTrips = {
  totalCount: 325,
  starredTripsCount: 5,
  last0To2HoursUpdatedTripsCount: 12,
  last2To4HoursUpdatedTripsCount: 28,
  last4PlusHoursUpdatedTripsCount: 285,
  trips: [
    {
      tripNumber: 10016841,
      loadBoardScheduleId: 3104048,
      originSic: {
        id: 103,
        code: "ATB",
        ownership: "V",
        lhRegionId: 3,
        timeZone: "America/New_York",
      },
      destinationSic: {
        id: 2,
        code: "LAX",
        ownership: "C",
        lhRegionId: 5,
        timeZone: "America/Los_Angeles",
      },
      stops: ["SEFL"],
      deadheadOrigin: "EWR",
      deadheadDestination: "ATB",
      bookingNumber: "123456",
      carrier: {
        id: 95128,
        name: "COVENANT TRANSPORT INC",
        code: "L004",
        isActive: true,
      },
      trailer: "123456",
      shipmentTags: ["CC", "UC"],
      pickupDate: new Date("2025-11-03T23:25:00"),
      eta: new Date("2025-11-07T18:00:00"),
      ata: null,
      tripStatus: "PLAN",
      isStarred: false,
      isNote: false,
      employeeDrivers: [
        { name: "SMITH, JOHN" },
        { name: "JOHNSON, MIKE" },
        { name: "WILLIAMS, DAVID" },
      ],
      ibCuttime: new Date("2025-11-04T16:30:00"),
      category: "RISK",
      latestModifiedOn: new Date("2025-11-03T10:22:00"),
    },
    {
      tripNumber: 10016843,
      loadBoardScheduleId: 3063160,
      originSic: {
        id: 103,
        code: "ATB",
        ownership: "V",
        lhRegionId: 3,
        timeZone: "America/New_York",
      },
      destinationSic: {
        id: 2,
        code: "LAX",
        ownership: "C",
        lhRegionId: 5,
        timeZone: "America/Los_Angeles",
      },
      stops: [],
      deadheadOrigin: "",
      deadheadDestination: "",
      bookingNumber: "789012",
      carrier: {
        id: 183026,
        name: "STARRY MANAGEMENT CO",
        code: "M271",
        isActive: true,
      },
      trailer: "TRL-002",
      shipmentTags: ["UC"],
      pickupDate: new Date("2025-11-04T08:00:00"),
      eta: new Date("2025-11-08T12:00:00"),
      ata: null,
      tripStatus: "DISP",
      isStarred: true,
      isNote: true,
      employeeDrivers: [],
      ibCuttime: new Date("2025-11-05T14:00:00"),
      category: "LATE",
      latestModifiedOn: new Date("2025-11-04T09:15:00"),
    },
    {
      tripNumber: 10016845,
      loadBoardScheduleId: 3063162,
      originSic: {
        id: 50,
        code: "DFW",
        ownership: "C",
        lhRegionId: 4,
        timeZone: "America/Chicago",
      },
      destinationSic: {
        id: 103,
        code: "ATB",
        ownership: "V",
        lhRegionId: 3,
        timeZone: "America/New_York",
      },
      stops: ["MEM", "BNA"],
      deadheadOrigin: "DAL",
      deadheadDestination: "",
      bookingNumber: "345678",
      carrier: {
        id: 95128,
        name: "COVENANT TRANSPORT INC",
        code: "L004",
        isActive: true,
      },
      trailer: "TRL-003",
      shipmentTags: ["CC", "APTR"],
      pickupDate: new Date("2025-11-05T06:00:00"),
      eta: new Date("2025-11-06T18:00:00"),
      ata: null,
      tripStatus: "ARVD",
      isStarred: false,
      isNote: false,
      employeeDrivers: [{ name: "BROWN, ROBERT" }],
      ibCuttime: new Date("2025-11-06T20:00:00"),
      category: "ON TIME",
      latestModifiedOn: new Date("2025-11-05T15:30:00"),
    },
    {
      tripNumber: 10016847,
      loadBoardScheduleId: 3063164,
      originSic: {
        id: 2,
        code: "LAX",
        ownership: "C",
        lhRegionId: 5,
        timeZone: "America/Los_Angeles",
      },
      destinationSic: {
        id: 50,
        code: "DFW",
        ownership: "C",
        lhRegionId: 4,
        timeZone: "America/Chicago",
      },
      stops: ["PHX"],
      deadheadOrigin: "",
      deadheadDestination: "FTW",
      bookingNumber: "901234",
      carrier: {
        id: 183026,
        name: "STARRY MANAGEMENT CO",
        code: "M271",
        isActive: true,
      },
      trailer: "",
      shipmentTags: [],
      pickupDate: new Date("2025-11-06T10:00:00"),
      eta: new Date("2025-11-07T22:00:00"),
      ata: new Date("2025-11-07T21:30:00"),
      tripStatus: "DLVD",
      isStarred: true,
      isNote: false,
      employeeDrivers: [{ name: "DAVIS, SARAH" }, { name: "MILLER, TOM" }],
      ibCuttime: null,
      category: "ON TIME",
      latestModifiedOn: new Date("2025-11-07T21:30:00"),
    },
    {
      tripNumber: 10016849,
      loadBoardScheduleId: 3063166,
      originSic: {
        id: 75,
        code: "ORD",
        ownership: "C",
        lhRegionId: 2,
        timeZone: "America/Chicago",
      },
      destinationSic: {
        id: 2,
        code: "LAX",
        ownership: "C",
        lhRegionId: 5,
        timeZone: "America/Los_Angeles",
      },
      stops: ["DEN", "SLC"],
      deadheadOrigin: "MDW",
      deadheadDestination: "ONT",
      bookingNumber: "567890",
      carrier: {
        id: 95128,
        name: "COVENANT TRANSPORT INC",
        code: "L004",
        isActive: true,
      },
      trailer: "TRL-005",
      shipmentTags: ["UC", "CC", "VOL"],
      pickupDate: new Date("2025-11-07T14:00:00"),
      eta: new Date("2025-11-09T08:00:00"),
      ata: null,
      tripStatus: "DISP",
      isStarred: false,
      isNote: true,
      employeeDrivers: [],
      ibCuttime: new Date("2025-11-09T10:00:00"),
      category: "AT RISK",
      latestModifiedOn: new Date("2025-11-07T16:45:00"),
    },
  ],
};

/**
 * Mock data for Transit Dashboard Shipments
 */
export const mockTransitDashboardShipments = {
  default: {
    totalcount: 20,
    shipments: [
      {
        shipmentId: 135392846,
        proNumber: "P9370245",
        tagsValue: null,
        tags: ["CC"],
        serviceDue: dayjs("2025-11-20T20:00:00"),
        pickupDate: dayjs("2025-11-17T17:00:00"),
        tripNumber: 10017305,
        shipperName: "FORUM SOLUTIONS",
        shipperZipCode: "30575",
        consigneeName: "DAYLIGHT SOLUTIONS LLC",
        consigneeZipCode: "92880",
        weight: 558,
        pallets: 1,
        pieces: 2,
        revenue: 33.0,
        originSicCode: "ATB-SEFL",
        destinationSicCode: "ONT",
        currentSicCode: "ATB-SEFL",
        originSic: null,
        destinationSic: null,
        currentSic: null,
        status: "LDDK",
      },
      {
        shipmentId: 135398473,
        proNumber: "180363327",
        tagsValue: null,
        tags: ["UC"],
        serviceDue: dayjs("2025-11-18T23:00:00"),
        pickupDate: dayjs("2025-11-14T21:00:00"),
        tripNumber: 10017305,
        shipperName: "GERARD DANIELS",
        shipperZipCode: "38310",
        consigneeName: "PENTAIR POOL PRODUCTS",
        consigneeZipCode: "93021",
        weight: 447,
        pallets: 1,
        pieces: 0,
        revenue: 377.68,
        originSicCode: "ATB-SEFL",
        destinationSicCode: "LAX",
        currentSicCode: "ATB-SEFL",
        originSic: null,
        destinationSic: null,
        currentSic: null,
        status: "LDDK",
      },
      {
        shipmentId: 135404921,
        proNumber: "P9373564",
        tagsValue: null,
        tags: ["APTR"],
        serviceDue: dayjs("2025-11-18T22:00:00"),
        pickupDate: dayjs("2025-11-14T19:00:00"),
        tripNumber: 10017305,
        shipperName: "ART & FRAME DIRECT",
        shipperZipCode: "32837",
        consigneeName: "MONIQUE KAGELE",
        consigneeZipCode: "92672",
        weight: 136,
        pallets: 1,
        pieces: 0,
        revenue: 394.09,
        originSicCode: "ATB-SEFL",
        destinationSicCode: "ONT",
        currentSicCode: "ATB-SEFL",
        originSic: null,
        destinationSic: null,
        currentSic: null,
        status: "LDDK",
      },
      {
        shipmentId: 135405099,
        proNumber: "P9373614",
        tagsValue: null,
        tags: ["APTR"],
        serviceDue: dayjs("2025-11-18T16:00:00"),
        pickupDate: dayjs("2025-11-14T13:00:00"),
        tripNumber: 10017305,
        shipperName: "WAREHOUSE SOLUTIONS",
        shipperZipCode: "30720",
        consigneeName: "PRO EQUITY MANAGEMENT",
        consigneeZipCode: "95825",
        weight: 455,
        pallets: 1,
        pieces: 13,
        revenue: 148.0,
        originSicCode: "ATB-SEFL",
        destinationSicCode: "SFO",
        currentSicCode: "ATB-SEFL",
        originSic: null,
        destinationSic: null,
        currentSic: null,
        status: "LDDK",
      },
      {
        shipmentId: 135406356,
        proNumber: "180363988",
        tagsValue: null,
        tags: ["APTR"],
        serviceDue: dayjs("2025-11-20T08:00:00"),
        pickupDate: dayjs("2025-11-14T06:00:00"),
        tripNumber: 10017305,
        shipperName: "RANDA ACCESSORIES",
        shipperZipCode: "70087",
        consigneeName: "SEINO @ CASUAL TEXTILES INC",
        consigneeZipCode: "90504",
        weight: 2083,
        pallets: 4,
        pieces: 0,
        revenue: 1030.02,
        originSicCode: "ATB-SEFL",
        destinationSicCode: "LAX",
        currentSicCode: "ATB-SEFL",
        originSic: null,
        destinationSic: null,
        currentSic: null,
        status: "LDDK",
      },
      {
        shipmentId: 135410519,
        proNumber: "P9375418",
        tagsValue: null,
        tags: ["APTR"],
        serviceDue: dayjs("2025-11-18T23:00:00"),
        pickupDate: dayjs("2025-11-17T20:00:00"),
        tripNumber: 10017305,
        shipperName: "DACKOR",
        shipperZipCode: "34787",
        consigneeName: "CORONA MILLWORKS",
        consigneeZipCode: "91710",
        weight: 163,
        pallets: 1,
        pieces: 0,
        revenue: 165.42,
        originSicCode: "ATB-SEFL",
        destinationSicCode: "ONT",
        currentSicCode: "ATB-SEFL",
        originSic: null,
        destinationSic: null,
        currentSic: null,
        status: "LDDK",
      },
      {
        shipmentId: 135414524,
        proNumber: "P9376497",
        tagsValue: null,
        tags: ["APTR"],
        serviceDue: dayjs("2025-11-21T17:00:00"),
        pickupDate: dayjs("2025-11-17T15:00:00"),
        tripNumber: 10017305,
        shipperName: "WESLEY DARNELL",
        shipperZipCode: "37043",
        consigneeName: "SPECIALIZED GERMAN RECYCLING",
        consigneeZipCode: "95742",
        weight: 438,
        pallets: 1,
        pieces: 1,
        revenue: 343.98,
        originSicCode: "ATB-SEFL",
        destinationSicCode: "SFO",
        currentSicCode: "ATB-SEFL",
        originSic: null,
        destinationSic: null,
        currentSic: null,
        status: "LDDK",
      },
    ],
  },
};

/**
 * Mock data for Trip Details feature in Transit Dashboard
 */
export const mockTransitDashboardTripDetails = {
  default: {
    sealNumber: "123456",
    cubageEstimate: 98,
    scacCode: "",
    closeDate: dayjs("2024-12-02T15:00:00"),
    departureTime: dayjs("2024-12-03T17:30:00"),
    startLoadEta: dayjs("2024-12-02T10:00:00"),
    gateCutDate: dayjs("2024-12-02T15:00:00"),
    mileage: 2600,
    ratePerMile: 1.5,
    accessorials: [
      { code: "DETEN", name: "Detention", cost: 50, isEditable: true },
      { code: "ROLLOVER", name: "Rollover", cost: 250, isEditable: true },
      { code: "STOPFEE", name: "Added Stop Fee", cost: 75, isEditable: true },
      {
        code: "LHOOFuelCg",
        name: "CA Supplementary Fuel",
        cost: 325,
        isEditable: false,
        qty: 2600,
        rate: 0.125,
      },
      { code: "TONU", name: "TONU", cost: 100, isEditable: true },
      {
        code: "LHDeadhead",
        name: "Deadhead",
        cost: 243.75,
        isEditable: false,
        qty: 150,
        rate: 1.625,
      },
    ],
    scheduleId: 3104449,
    loadPairScheduleId: 3114779,
    bookingNumber: "1234567",
    bookingStatus: "Confirmed",
    tripStatus: "LDDK",
    originSicCode: "ATB",
    destinationSicCode: "ONT",
    loadingDate: dayjs("2024-12-02T00:00:00"),
    pickupDate: dayjs("2024-12-02T10:00:00"),
    serviceType: "1-way",
    carrierName: "Testing Carrier",
    carrierCode: "TEST",
    tripNumber: 10017491,
    trailerNumber: "428017",
    deadheads: [{ originSicCode: "ONT", destinationSicCode: "LAX" }],
    stops: ["CHT", "DAL", "ONT", "LAX"],
    tripPriority: 1,
    totalRevenue: 826,
    totalCost: 750,
    netLinehaul: 76,
    isPublished: true,
    isCancelled: false,
    loadType: "Start",
    hasLoadPair: false,
    tonu: 0,
    employeeDrivers: [
      {
        id: 2354,
        loadBoardScheduleId: 3104449,
        name: "DIAZ, MARIO ANTONIO",
        driverId: 9770,
        order: 1,
        ratePerMile: 0.5,
      },
      {
        id: 2355,
        loadBoardScheduleId: 3104449,
        name: "ATWAL, GURTEJ SINGH",
        driverId: 9755,
        order: 2,
        ratePerMile: 0.6,
      },
      {
        id: 2356,
        loadBoardScheduleId: 3104449,
        name: "HEREDIA, EDGAR",
        driverId: 10255,
        order: 3,
        ratePerMile: 0.4,
      },
    ],
    carrierRatePerMile: 0,
    originSic: {
      id: 1,
      code: "ATB-SEFL",
      lhRegionId: 1,
      ownership: "C",
      timeZone: "America/New_York",
    },
    destinationSic: {
      id: 2,
      code: "ONT",
      lhRegionId: 4,
      ownership: "C",
      timeZone: "America/Los_Angeles",
    },
    totalBills: 24,
    totalWeight: 48000,
    ucBillsCount: 2,
    ccBillsCount: 2,
    apptBillsCount: 0,
    volBillsCount: 0,
    ltlBillsCount: 4,
    loadedBills: 4,
    loadedWeight: 5799,
    piecesCount: 2,
    palletsCount: 6,
    ucBillsTotalWeight: 900,
    ccBillsTotalWeight: 800,
    volBillsTotalWeight: 0,
    apptBillsTotalWeight: 0,
    ltlBillsTotalWeight: 5799,
    rolloverFee: 0,
    isLoadAndHold: true,
    currentSealNumber: null,
    eta: null,
    isStarred: true,
    etaStatus: null,
    etaStatusTime: null,
    latestUpdate: dayjs("2024-12-02T15:38:00"),
    gateCutDay: null,
    gateCutTime: null,
    ibCutTime: null,
    shipmentDestinationDetails: [],
    shipmentsWithIssues: [],
    groupedShipmentsByStop: [
      {
        title: "Stop 1",
        tagCode: "CHT",
        isDestination: false,
        data: {
          ata: dayjs("2024-12-02T17:30:00"),
          departureTime: dayjs("2024-12-02T15:00:00"),
          ibCutTime: dayjs("2024-12-02T10:00:00"),
          transitStatus: "LATE",
        },
      },
      {
        title: "Stop 2",
        tagCode: "DAL",
        isDestination: false,
        data: {
          eta: dayjs("2024-12-02T17:30:00"),
          departureTime: dayjs("2024-12-02T15:00:00"),
          ibCutTime: dayjs("2024-12-02T10:00:00"),
          transitStatus: "LATE",
        },
      },
      {
        title: "Final Destination",
        tagCode: "ONT",
        isDestination: true,
        data: {
          eta: dayjs("2024-12-02T17:30:00"),
          departureTime: dayjs("2024-12-02T15:00:00"),
          ibCutTime: dayjs("2024-12-02T10:00:00"),
          transitStatus: "LATE",
        },
      },
    ] as Stop[],
    shipments: [],
    driverCheckInDetails: [],
    estimatedDepartureTime: dayjs(),
    isDyltTrailer: false,
  },
} as const satisfies Record<string, TripDetails>;

/**
 * Mock data for Trip Documents feature in Transit Dashboard
 */
export const mockTripDocuments = [
  {
    id: 1,
    documentType: "Invoice",
    documentName: "INV-2024-10017491.pdf",
    // The toDate() will be removed after the API integration for ticket LH-2513 has been completed.
    uploadedAt: dayjs("2024-12-02T10:00:00").toDate(),
    uploadedBy: "John Smith",
  },
  {
    id: 2,
    documentType: "Carrier bill of lading",
    documentName: "BOL-TEST-1234567.pdf",
    // The toDate() will be removed after the API integration for ticket LH-2513 has been completed.
    uploadedAt: dayjs("2024-12-02T10:00:00").toDate(),
    uploadedBy: "Sarah Johnson",
  },
];

/**
 * Mock data for Trip Notes feature in Transit Dashboard
 */
export const mockTripNotes = {
  default: [
    {
      id: 1,
      content: "Test Note",
      createdBy: "Test User",
      createdOn: dayjs("2024-12-02T10:00:00"),
      modifiedBy: "Test User",
      modifiedOn: dayjs("2024-12-02T10:00:00"),
      isEdited: false,
      scheduleId: 10018634,
      creatorId: "7fd75d50-622e-4258-9027-606eb0f11809",
    },
  ],
};

/**
 * Mock data for Bulk Request Trips by Carrier
 * Returns trips in the format expected by the bulk request API
 */
export const mockBulkRequestTripsByCarrier = {
  L004: {
    totalCount: 5,
    trips: [
      {
        tripNumber: 294039,
        loadBoardScheduleId: 3104817,
        origin: {
          id: 101,
          code: "ATL",
          ownership: "C",
          lhRegionId: 1,
          timeZone: "America/New_York",
        },
        destination: {
          id: 102,
          code: "SFO",
          ownership: "C",
          lhRegionId: 5,
          timeZone: "America/Los_Angeles",
        },
        stops: ["CHT"],
        bookingNumber: "123456",
        carrier: {
          id: 92027,
          name: "Jackson Transport",
          code: "L004",
          isActive: true,
        },
        trailerNumber: "123456",
        eta: new Date("2024-06-23T15:00:00"),
        status: "ENRT",
        isStarred: true,
        ibCutTime: new Date("2024-06-23T12:00:00"),
        etaStatus: "LATE",
        lastModifiedOn: new Date("2024-06-23T14:00:00"),
        employeeDrivers: [],
      },
      {
        tripNumber: 346383,
        loadBoardScheduleId: 3104818,
        origin: {
          id: 101,
          code: "ATL",
          ownership: "C",
          lhRegionId: 1,
          timeZone: "America/New_York",
        },
        destination: {
          id: 102,
          code: "SFO",
          ownership: "C",
          lhRegionId: 5,
          timeZone: "America/Los_Angeles",
        },
        stops: ["CHT"],
        bookingNumber: "123457",
        carrier: {
          id: 92027,
          name: "Jackson Transport",
          code: "M027",
          isActive: true,
        },
        trailerNumber: "123457",
        eta: new Date("2024-06-23T15:00:00"),
        status: "UNLD",
        isStarred: false,
        ibCutTime: new Date("2024-06-23T12:00:00"),
        etaStatus: "ON TIME",
        lastModifiedOn: new Date(),
        employeeDrivers: [],
      },
      {
        tripNumber: 58363,
        loadBoardScheduleId: 3104819,
        origin: {
          id: 101,
          code: "ATL",
          ownership: "C",
          lhRegionId: 1,
          timeZone: "America/New_York",
        },
        destination: {
          id: 102,
          code: "SFO",
          ownership: "C",
          lhRegionId: 5,
          timeZone: "America/Los_Angeles",
        },
        stops: ["CHT"],
        bookingNumber: "123458",
        carrier: {
          id: 92027,
          name: "Jackson Transport",
          code: "M027",
          isActive: true,
        },
        trailerNumber: "123458",
        eta: new Date("2024-06-23T15:00:00"),
        status: "ARIV",
        isStarred: false,
        ibCutTime: new Date("2024-06-23T12:00:00"),
        etaStatus: "ON TIME",
        lastModifiedOn: new Date(),
        employeeDrivers: [],
      },
      {
        tripNumber: 103734,
        loadBoardScheduleId: 3104820,
        origin: {
          id: 101,
          code: "ATL",
          ownership: "C",
          lhRegionId: 1,
          timeZone: "America/New_York",
        },
        destination: {
          id: 102,
          code: "SFO",
          ownership: "C",
          lhRegionId: 5,
          timeZone: "America/Los_Angeles",
        },
        stops: ["CHT"],
        bookingNumber: "123459",
        carrier: {
          id: 92027,
          name: "Jackson Transport",
          code: "M027",
          isActive: true,
        },
        trailerNumber: "123459",
        eta: new Date("2024-06-23T15:00:00"),
        status: "ENRT",
        isStarred: true,
        ibCutTime: new Date("2024-06-23T12:00:00"),
        etaStatus: "AT RISK",
        lastModifiedOn: new Date(),
        employeeDrivers: [],
      },
      {
        tripNumber: 404840,
        loadBoardScheduleId: 3104821,
        origin: {
          id: 101,
          code: "ATL",
          ownership: "C",
          lhRegionId: 1,
          timeZone: "America/New_York",
        },
        destination: {
          id: 102,
          code: "SFO",
          ownership: "C",
          lhRegionId: 5,
          timeZone: "America/Los_Angeles",
        },
        stops: ["CHT"],
        bookingNumber: "123460",
        carrier: {
          id: 92027,
          name: "Jackson Transport",
          code: "M027",
          isActive: true,
        },
        trailerNumber: "123460",
        eta: new Date("2024-06-23T15:00:00"),
        status: "ENRT",
        isStarred: false,
        ibCutTime: new Date("2024-06-23T12:00:00"),
        etaStatus: "LATE",
        lastModifiedOn: new Date(),
        employeeDrivers: [],
      },
    ],
  },
};
